module.exports = __webpack_public_path__ + "assets/flipper.f86727add09b3891e9e6db6fe144fa10.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/flipper.png
// module id = 138
// module chunks = 0